export enum TaxRegime {
    SimplesNacional = 1,
    LucroPresumido = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/TaxRegime.ts